import { useAuth } from 'context/AuthContext'
import useBreakpoint from 'hooks/useBreakpoint'
import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Roles } from 'utils/enums'
import Logout from '../../Logout'
import MobileSideBar from '../SideBar/Mobile'
import * as S from './styles'

export const NAV_BAR_HEIGHT_PADDING = 'pt-[9vh]'
export const NAV_BAR_HEIGHT = 'h-[9vh]'

const rolesWithSideBar = [Roles.Admin.role, Roles.Client.role, Roles.Mediator.role]

function NavBar() {
  const { user } = useAuth()
  const isBigScreen = useBreakpoint()

  const [displayedUser, setDisplayedUser] = useState(null)

  return (
    <>
      <S.NavBar
        className={`flex justify-between items-center fixed top-0 right-0 w-full ${NAV_BAR_HEIGHT} p-[max(1vw,1vh)] text-[#f9f9f9] shadow-md z-10`}
      >
        <div className='flex items-center gap-2'>
          {rolesWithSideBar.includes(user.role) && !isBigScreen && (
            <MobileSideBar />
          )}
          <span>
            {(displayedUser || user)?.firstName}
            {' '}
            {(displayedUser || user)?.lastName}
          </span>
        </div>
        <div className='flex items-center'>
          <span>
            {displayedUser?.speciality || user?.companyName}
          </span>
          <Logout />
        </div>
      </S.NavBar>
      <main className={`min-h-[100vh] ${NAV_BAR_HEIGHT_PADDING}`}>
        <Outlet context={setDisplayedUser}/>
      </main>
    </>
  )
}

export default NavBar
